import store from '@/store'
export const routerBeforeEach = (to, from, next) => {
  // let token = xyUtils.getCookie('.XYTOKEN') ? xyUtils.getCookie('.XYTOKEN') : ''
  document.title = to.meta.title || ''

  const pathReg = /^(singleReportunion|totalReportunion)$/
  const { path } = to

  const pathCheck = pathReg.test(path.slice(1))

  store.commit('setUnionReport', pathCheck)

  if (to.matched.some(record => record.meta.requireAuth)) {
    next()
  } else {
    next()
  }
}
